import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import React, { useEffect, useMemo, useState } from "react";
import { myVFL } from "app/_services/ehs/VFLService";
import { FiEdit3, FiEye } from "react-icons/fi";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { Link } from "react-router-dom";
import toastr from "toastr";
import {
  getVFLStatusClass,
  VFL_STATUS,
  VFL_STATUS_COLUMN,
  VFL_STATUS_VIEW,
} from "./CONSTANTS";
import { DDMMYYYYFormat, DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";
import { formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { ACTIVE_MODULE } from "app/_constants/constant";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

function MyVFL() {
  const [VFLList, setVFLList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const sortableColumn = useMemo(
    () => [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "vflId",
        text: "VFL Id",
        sort: true,
        formatter: (vflId, row) => (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">View</Tooltip>}
          >
            <Link
              className="icons text-cyanBlue"
              to={
                row.vflStatus === VFL_STATUS.completed
                  ? "/health-safety-and-environment/vfl/completion/view/" + row.id
                  : "/health-safety-and-environment/vfl/view/" + row.id
              }
            >
              {vflId}
            </Link>
          </OverlayTrigger>
        ),
      },
      // {
      //   dataField: "vflScheduledDateTimeView",
      //   text: "VFL Scheduled Date",
      //   sort: true,
      // },
      {
        dataField: "mineName",
        text: "Location Name",
        sort: true,
      },
      {
        dataField: "siteData.siteId",
        text: "Location Code",
        sort: true,
        formatter: (ehsSite, row) => {
          return (
            <span title={row?.siteData ? row?.siteData?.name : ""}>
              {row?.siteData ? row?.siteData?.siteId : ""}
            </span>
          );
        },
      },
      {
        dataField: "vflExecutiveName",
        text: "VFL Executive",
        sort: true,
      },
      {
        dataField: "ehs_area_of_operations.name",
        text: "Area",
        sort: true,
      },
      {
        dataField: "departmentId",
        text: "Department",
        sort: true,
      },
      {
        dataField: "contractorInvolved",
        text: "Contractor",
        sort: true,
        formatter: (contractorInvolved) => {
          return contractorInvolved ? "Yes" : "No";
        },
      },
      {
        dataField: "vflStatusView",
        text: "Status",
        sort: true,
        formatter: (status, row) => {
          return VFL_STATUS_COLUMN(row?.vflStatus, row);
        },
      },
      {
        dataField: "createdAt",
        text: "Time Stamp",
        sort: true,
        formatter: (createdAt, row) => {
          return DDMMYYYYHHMMAFormat(createdAt);
        },
      },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          return (
            <div className="actionIconsGroup">
              {(row.vflStatus === "draft" || row.vflStatus === "rejected") && (
                <CustomTooltip tooltip={"Edit"}>
                  <Link
                    to={"/health-safety-and-environment/vfl/schedule/" + row.id}
                    className="icons text-cyanBlue"
                  >
                    <FiEdit3 />
                  </Link>
                </CustomTooltip>
              )}

              <CustomTooltip tooltip={"View"}>
                <Link
                  to={"/health-safety-and-environment/vfl/view/" + row.id}
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </CustomTooltip>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    // myVFL().then((response) => {
    //   if (!response?.status)
    //     return toastr.info(response?.message || "Something Went Wrong");

    //   setVFLList(response.data);
    // });

    const fetchData = async () => {
      try {
        const response = await myVFL();
        if (!response?.data) {
          // Handle the case where data is not received
          setIsLoading(false);
          return;
        }
        setVFLList(
          response.data?.map((d) => ({
            ...d,
            vflStatusView: !d?.executiveReturn
              ? VFL_STATUS_VIEW[d?.vflStatus]
              : VFL_STATUS_VIEW?.ExecutiveReturn,
            vflExecutiveName: d?.vflOfficerData
              ? `${d?.vflOfficerData?.firstName} ${d?.vflOfficerData?.lastName}`
              : "",
          }))
        );
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Visible Felt Leadership",
            path: "/health-safety-and-environment/vfl",
          },
          {
            name: "My VFLs",
          },
        ]}
        breadCrumbsText="User_Management_User_Registration"
        module={ACTIVE_MODULE.vfl}
      />

      <div className="card p-4 mb-4 overflow-visible">
        <div className="simple-card-title">
          <h3 className="text-capitalize mb-1">My VFLs</h3>
          <BackBtn url={"/health-safety-and-environment/vfl"} />
        </div>
        {!isLoading ? (
          <SearchBootstrapTable
            searchKey={"myVFLDesktopSearch"}
            data={VFLList}
            columns={sortableColumn}
            tableKey="myVFL"
            defaultHideColumn={["mineName"]}
          />
        ) : (
          <NetZeroLoader />
        )}
      </div>
    </div>
  );
}

export default MyVFL;
